// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Link, Routes, Route, Navigate } from 'react-router-dom';
import './App.css'; // Import the CSS file
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from "./routes/AppRoutes";
import ApolloApp from './apollo-client';
import { GeneralInfoProvider } from './utils/GeneralnfoContext.js';
import ErrorBoundary from "./utils/ErrorBoundary";


function App() {


  return (
    <React.Fragment>
      <ApolloApp>
        <GeneralInfoProvider>
          <ErrorBoundary>
            <AppRoutes></AppRoutes>
          </ErrorBoundary>
        </GeneralInfoProvider>
      </ApolloApp>
    </React.Fragment>
  );
}

export default App;
